//------------------------------------------------------ externos
import { useState } from "react";
//------------------------------------------------------ funciones
import {
  leerCodigoDeBarras,
  mostrarCodigo,
  problemaDelCodigo,
} from "../../shared/stockEdicion";

/* Los códigos de barras de un artículo, adentro de su edición.
 *
 * ── NO SE ESCRIBE NADA HASTA GUARDAR ───────────────────────────────────────
 *
 * Arriba de la ficha en edición dice «Nada cambia hasta apretar Guardar», y
 * tiene que seguir siendo cierto acá: agregar o quitar un código cambia la
 * lista en pantalla y nada más. El que escribe es `submitStock`, después de
 * guardar la ficha. Un código que se borrara al tocar la cruz, en un
 * formulario que tiene «Cancelar», sería el único dato que Cancelar no
 * devuelve.
 *
 * ── SE LEE COMO LO LEE FLOTABOT ────────────────────────────────────────────
 *
 * Lo tipeado pasa por `leerCodigoDeBarras`, la misma normalización del
 * escaneo: el EAN «7799115000779» se guarda «07799115000779» y es el que el
 * atajo del iPhone va a encontrar. Se muestra como está impreso en la caja.
 */
const ORIGEN = {
  atajo: "escaneado con el iPhone",
  whatsapp: "por WhatsApp",
  hub: "desde el hub",
  catalogo: "estaba en el catálogo",
};

const CodigosDeBarras = ({
  codigos = [],
  onChange,
  cargando = false,
  error = "",
  editable = true,
}) => {
  const [texto, setTexto] = useState("");
  const [problema, setProblema] = useState("");

  const agregar = () => {
    const lc = leerCodigoDeBarras(texto);
    const p = problemaDelCodigo(lc);
    if (p) {
      setProblema(p);
      return;
    }
    if (codigos.some((c) => c.codigo === lc.codigo)) {
      setProblema("Ese código ya está en la lista.");
      return;
    }
    onChange?.([...codigos, { codigo: lc.codigo, formato: lc.forma, origen: "hub", nuevo: true }]);
    setTexto("");
    setProblema("");
  };

  const quitar = (codigo) =>
    onChange?.(codigos.filter((c) => c.codigo !== codigo));

  return (
    <div className="codigos-barras">
      <strong className="form-info-title">Códigos de barras</strong>
      {cargando && <p className="codigos-barras-nota">Buscando los códigos…</p>}
      {/* Sin poder leerlos no se ofrece cargar: quien no ve los tres que ya
          tiene los cargaría de nuevo, o creería que no tiene ninguno. */}
      {!cargando && error && (
        <p className="codigos-barras-error">
          No pude leer los códigos de este artículo. Cerrá y probá de nuevo.
        </p>
      )}
      {!cargando && !error && codigos.length === 0 && (
        <p className="codigos-barras-nota">
          Todavía no tiene. Con uno cargado, escanearlo con el iPhone lo encuentra.
        </p>
      )}
      {!cargando && !error && codigos.length > 0 && (
        <ul className="codigos-barras-lista">
          {codigos.map((c) => (
            <li key={c.codigo}>
              <span className="codigos-barras-codigo">{mostrarCodigo(c.codigo)}</span>
              <span className="codigos-barras-de">
                {c.nuevo
                  ? "se agrega al guardar"
                  : [ORIGEN[c.origen], c.creado_nombre].filter(Boolean).join(" · ")}
              </span>
              {editable && (
                <button
                  type="button"
                  className="codigos-barras-quitar"
                  onClick={() => quitar(c.codigo)}
                  aria-label={`Quitar el código ${mostrarCodigo(c.codigo)}`}
                >
                  Quitar
                </button>
              )}
            </li>
          ))}
        </ul>
      )}
      {editable && !cargando && !error && (
        <div className="codigos-barras-agregar">
          <input
            className="form-input"
            value={texto}
            onChange={(e) => {
              setTexto(e.target.value);
              setProblema("");
            }}
            /* Un lector de código de barras USB «tipea» el código y termina
               con Enter: Enter agrega, y no manda el formulario entero. */
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                agregar();
              }
            }}
            placeholder="Escribí o escaneá un código"
            aria-label="Código de barras nuevo"
          />
          <button type="button" className="codigos-barras-boton" onClick={agregar}>
            Agregar
          </button>
        </div>
      )}
      {problema && <p className="codigos-barras-error">{problema}</p>}
    </div>
  );
};

export default CodigosDeBarras;
